// Corrige o áudio gravado no painel saindo "travado"/picotado.
//
// A gravação usa `mic-recorder-to-mp3`, que monta um ScriptProcessorNode com
// `createScriptProcessor(0, 1, 1)` — o 0 deixa o Chrome escolher o tamanho do
// buffer (pode cair em 1024 amostras = ~23 ms) — e codifica o MP3 dentro do
// callback, na thread principal. Se a aba engasga por mais tempo que um buffer,
// o callback perde blocos inteiros: o áudio encurta e cada emenda vira um
// click de banda larga. É o "áudio travando" que o Rio Brás reportou em
// 07/08/2026 (ticket 2): 6 dos 11 áudios gravados tinham ~4 clicks/s, enquanto
// os do golden, com código idêntico, saíam limpos.
//
// Forçar 16384 amostras (~370 ms a 44,1 kHz) dá folga suficiente para o
// encoder atravessar os engasgos. Medido em bancada (Chrome headless, mic
// falso, mesma carga sintética): energia acima de 17 kHz em relação à fala
// passou de -62 dB (picotado) para -98,5 dB (limpo).
//
// O patch fica aqui, e não em node_modules, para sobreviver a `npm install`.
// Vale para todos os pontos que gravam áudio (MessageInput e InternalChat),
// porque age no protótipo do AudioContext.
const RECORDER_BUFFER_SIZE = 16384;

(() => {
  if (typeof window === "undefined") return;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx || Ctx.prototype.__sabeRecorderBufferFix) return;

  const original = Ctx.prototype.createScriptProcessor;
  if (typeof original !== "function") return;

  Ctx.prototype.createScriptProcessor = function (size, inputs, outputs) {
    return original.call(this, size || RECORDER_BUFFER_SIZE, inputs, outputs);
  };
  Ctx.prototype.__sabeRecorderBufferFix = true;
})();

export default RECORDER_BUFFER_SIZE;
